import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { GMapSelector } from './GMapSelector';
import { CreatePredioDto, Point, Predio } from '../../../service/types/types';
import { PrediosService } from '../../../service/predios.service';

interface PredioFormProps {
  predio?: Predio;
  onSaved: (predio: Predio) => void;
  onCancel?: () => void;
}

export default function PredioForm({ predio, onSaved, onCancel }: PredioFormProps) {
  const [name, setName] = useState(predio?.name ?? '');
  const [location, setLocation] = useState<Point | undefined>(predio?.location);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const isEditing = !!predio?.id;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Ingrese un nombre para el predio');
      return;
    }
    if (!location) {
      setError('Seleccione una ubicación en el mapa');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const dto: CreatePredioDto = { name: name.trim(), location };
      const saved = isEditing ? await PrediosService.update(predio!.id, dto) : await PrediosService.create(dto);
      if (saved) onSaved(saved);
    } catch (err) {
      console.error('Error saving predio:', err);
      setError('No se pudo guardar el predio.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && <div className="text-danger small mb-2">{error}</div>}
      <Form.Group className="mb-3">
        <Form.Label>Ubicación</Form.Label>
        <GMapSelector initialCenter={predio?.location.coordinates} onSelect={setLocation} />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Nombre</Form.Label>
        <Form.Control value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre del predio" />
      </Form.Group>
      <div className="d-flex gap-2">
        <Button type="submit" variant="success" disabled={saving}>
          {saving ? 'Guardando...' : 'Guardar'}
        </Button>
        {onCancel && (
          <Button type="button" variant="outline-secondary" onClick={onCancel}>
            Cancelar
          </Button>
        )}
      </div>
    </Form>
  );
}
